import { useTranslations } from 'next-intl';

import { BarCategory } from '../../utils';
import CategoryItem from './CategoryItem';

interface Props {
  barId: string;
  service: 'bar' | 'take_away';
  data: BarCategory[];
}

export default function Categories(props: Props) {
  const t = useTranslations('bar');

  return (
    <div className="container mx-auto">
      <h2 className="font-bold mb-3 pt-6 text-greyscale-title">
        {t('detail.categories')}
      </h2>
      <ul className="pl-0 grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-4">
        {props.data.map((category) => (
          <CategoryItem
            id={category.id}
            icon={category.icon_url}
            name={category.name}
            key={category.id}
            barId={props.barId}
            service={props.service}
            categoryId={category.id}
          />
        ))}
      </ul>
    </div>
  );
}
